module.exports = __webpack_public_path__ + "img/license.6952f7ef.png";